<template>
  <div>
    <!--    <v-img
          style="opacity: 0.4; z-index: 0; position:fixed;"
          :src="intent.background || ''"
          height="100%"
          width="100%"
          contain
          position="center"
      ></v-img>-->
    <v-navigation-drawer
        v-model="drawer"
        :clipped="$vuetify.breakpoint.lgAndUp"
        style="height:100%"
        app
    >
      <v-list-item>
        <v-list-item-title>
          {{sessionUser.name}}
        </v-list-item-title>
        <v-list-item-icon>
          <v-icon v-if="isLogin" @click="logout">mdi-logout</v-icon>
          <v-icon v-else @click="$store.dispatch('auth/openLoginDialog')">mdi-login</v-icon>
        </v-list-item-icon>
        <v-list-item-action>
          <v-icon @click="drawer = false">mdi-close</v-icon>
        </v-list-item-action>
      </v-list-item>
      <drawer-list/>
    </v-navigation-drawer>

    <v-app-bar
        :clipped-left="$vuetify.breakpoint.lgAndUp"
        app
        hide-on-scroll
        color="light-green accent-1"
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <router-link to="/">
        <div>
          <v-toolbar-title
              class="ml-0 pl-4"
          >
            <span>Tennis System</span>
            <v-icon>mdi-tennis</v-icon>
          </v-toolbar-title>
        </div>
      </router-link>

    </v-app-bar>
    <v-main>
      <transition name="wipe-up">
        <router-view :intent="intent" :picker.sync="picker"/>
      </transition>
    </v-main>

    <login v-model="login" @login="login = false"></login>
  </div>
</template>

<script>
import Login from "@/views/Login";
import {mapGetters} from "vuex";
import DrawerList from "@/components/frame/drawerList";
export default {
  name: "defaultLayout",
  components: {DrawerList, Login},
  data: function () {
    return {
      intent: {
        dateRange: [],
        newRecords: [],
        background: ''
      },
      login: false,
      dialog: false,
      picker: true,
      drawer: false,
    }
  },
  computed: {
    ...mapGetters(['loginDialog']),
  },
  watch: {
    loginDialog(){
      this.login = true
    }
  },
  methods: {
    async logout () {
      await this.$store.dispatch('auth/logout')
      this.$forceUpdate()
    },
    manageDialogOpen () {
      if (!this.$session.exists()) return this.login = !this.login
      this.dialog = true
    }
  }
}
</script>

<style lang="scss">
.v-toolbar__content {
  flex-wrap: wrap;
}
</style>